import React, { useState, useEffect, useContext } from 'react';
import { SystemConfigContext } from "../context/SystemConfigContext";
import { useMemo } from 'react';
import _ from 'lodash';

import CallCostsComponent from './CallCostsComponent';
import TelecomServicesSection from './TelecomServiceSection'; 

import { Phone, Mail, User, Building2, CheckCircle, AlertCircle, Search, ChevronDown, ChevronUp, Settings, Wifi, Globe, Monitor, Smartphone, Headphones, Tablet, Plus, X, Edit2, CalculatorIcon } from 'lucide-react';
import connectionService from '../services/connectionService';
import { fetchMechanicsData } from '../services/mechanicsService'; 
import { fetchMechanicServices } from '../services/mechanicsService';
import QuoteProgressService from '../services/quoteProgressService';
import { 
  saveSystemConfig, 
  getSystemConfig,
  updateSystemConfig 
} from '../services/systemConfigService';

const SystemConfig = ({ selectedConnectionId, onSaveSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLineServicesOpen, setIsLineServicesOpen] = useState(false);
  const [isHardwareOpen, setIsHardwareOpen] = useState(false);
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
 
  const [selectedPhoneModel, setSelectedPhoneModel] = useState('');
  const {
    lineRequirements,
    setLineRequirements,
    currentLines,
    setCurrentLines,
    dataBroadband,
    setDataBroadband,
    hardwareItems,
    setHardwareItems,
    additionalHardware,
    setAdditionalHardware,
    resetSystemConfig,
    serviceChargesData,
    setServiceChargesData,
    leaseCalculatorData,
    setLeaseCalculatorData,
    digitalServicesData,
    setDigitalServicesData,
    savedDigitalServices,
    setSavedDigitalServices,
    telecomServices,
    setTelecomServices,
    notes,        // ← add
    setNotes,     // ← add
    itServicesData,
    setItServicesData,
  } = useContext(SystemConfigContext);

  // ── Unsaved changes tracking ──
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [savedOnce, setSavedOnce] = useState(false);

  const [showForm, setShowForm] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [emailExtraInput, setEmailExtraInput] = useState(0);
  const [editingId, setEditingId] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [autoCalculateMobileApp, setAutoCalculateMobileApp] = useState(true);
  const [error, setError] = useState(null);
  const [services, setServices] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [adminUpdate, setUpdatedByAdmin] = useState(0);
  const [existingConfigId, setExistingConfigId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(false);
  const [licenses, setLicenses] = useState([]);
  const [itSupportPricing, setItSupportPricing] = useState([]);
  const [isItServicesOpen, setIsItServicesOpen] = useState(false);

  useEffect(() => {
    if (selectedConnectionId) {
      setShowForm(true);
    }
  }, [selectedConnectionId]);

  // Sync dropdown to reflect any saved dropdown model with quantity > 0 on load
useEffect(() => {
  if (!selectedPhoneModel) {
    const dropdownModels = ['Grandstream 3470', 'Grandstream 3480', 'Cisco 9871'];
    const savedModel = hardwareItems.find(
      item => dropdownModels.includes(item.name) && (item.quantity ?? 0) > 0
    );
    if (savedModel) {
      setSelectedPhoneModel(savedModel.name);
    }
  }
}, [hardwareItems]);
  const [newItem, setNewItem] = useState({
    name: '',
    quantity: 0,
    category: 'Phone',
    icon: '📞'
  });

  const categories = [
    { name: 'Phone', icon: '📞' },
    { name: 'Audio', icon: '🔔' },
    { name: 'Network', icon: '📶' },
    { name: 'Display', icon: '📺' },
    { name: 'Tablet', icon: '📱' },
    { name: 'Software', icon: '💻' },
    { name: 'Other', icon: '⚙️' }
  ];

  const getIconComponent = (category) => {
    switch (category) {
      case 'Phone': return <Phone className="w-5 h-5" />;
      case 'Audio': return <Headphones className="w-5 h-5" />;
      case 'Network': return <Wifi className="w-5 h-5" />;
      case 'Display': return <Monitor className="w-5 h-5" />;
      case 'Tablet': return <Tablet className="w-5 h-5" />;
      case 'Software': return <Smartphone className="w-5 h-5" />;
      default: return <Monitor className="w-5 h-5" />;
    }
  };

  const handleAddItem = () => {
    if (newItem.name.trim()) {
      const categoryData = categories.find(cat => cat.name === newItem.category);
      setHardwareItems([...hardwareItems, {
        id: Date.now(),
        ...newItem,
        icon: categoryData?.icon || '⚙️'
      }]);
      setNewItem({ name: '', quantity: 0, category: 'Phone', icon: '📞' });
      setShowAddForm(false);
      setHasUnsavedChanges(true);
    }
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = telecomServices.map((service, i) =>
      i === index ? { ...service, [field]: value } : service
    );
    setTelecomServices(updatedServices);
    setHasUnsavedChanges(true);
  };

  const handleAddService = () => {
    setTelecomServices([
      ...telecomServices,
      {
        id: Date.now(),
        description: '',
        service_type: '',
        existing_tel_no: '',
        existing_lines: '',
        postcode: ''
      }
    ]);
    setHasUnsavedChanges(true);
  };

  const handleRemoveService = (index) => {
    if (telecomServices.length > 1) {
      setTelecomServices(telecomServices.filter((_, i) => i !== index));
      setHasUnsavedChanges(true);
    }
  };

  useEffect(() => {
    const getMechanicsUcmIp = async () => {
      try {
        const response = await fetchMechanicsData();
        console.log("response",response);
        setServices(response.data.services);
        setEquipments(response.data.equipment);
        setLicenses(response.data.licenses || []);
        setItSupportPricing(response.data.it_support || []);
      } catch (error) {
        console.error('Failed to fetch UCM IP PBX:', error);
      }
    };

    getMechanicsUcmIp();

    const routerTotal = currentLines.adslFttcBroadband +
      currentLines.new4g5gBroadband +
      currentLines.fttpSogeaBroadband +
      dataBroadband.starlinkBroadband +
      dataBroadband.leasedLines;

    setAdditionalHardware(prev =>
      prev.map(item => {
        if (
          item.name === 'Router' ||
          item.name === 'Draytek 2865LAC' ||
          item.name === 'Netgear GS108LP'
        ) {
          return { ...item, quantity: routerTotal };
        }
        return item;
      })
    );
  }, [currentLines, dataBroadband]);

  const totalEmails = useMemo(() => {
    const t54w = hardwareItems.find(item => item.name === 'T54W')?.quantity || 0;
    const t57w = hardwareItems.find(item => item.name === 'T57W')?.quantity || 0;
    const ipDectHandset = hardwareItems.find(item => item.name === 'Yealink W73H DECT')?.quantity || 0;
    return (parseInt(emailExtraInput) || 0) + t54w + t57w + ipDectHandset;
  }, [hardwareItems, emailExtraInput]);

  const handleLineRequirementChange = (field, value) => {
    setLineRequirements(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

  const handleCurrentLinesChange = (field, value) => {
    setCurrentLines(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

  const handleDataBroadbandChange = (field, value) => {
    setDataBroadband(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

  const handleStationsChange = (value) => {
    setItServicesData(prev => ({
      ...prev,
      numberOfStations: value === '' ? '' : parseInt(value) || 0
    }));
    setHasUnsavedChanges(true);
  };

  const handleTogglePackage = (key, checked) => {
    setItServicesData(prev => {
      const current = prev.selectedPackages || [];
      return {
        ...prev,
        selectedPackages: checked
          ? [...current, key]
          : current.filter(k => k !== key)
      };
    });
    setHasUnsavedChanges(true);
  };

  const handleLicenceQuantityChange = (licenseId, value) => {
    const qty = value === '' ? '' : parseInt(value) || 0;
    setItServicesData(prev => ({
      ...prev,
      licenceQuantities: { ...prev.licenceQuantities, [licenseId]: qty }
    }));
    setHasUnsavedChanges(true);
  };

  const handleEditItem = (id, field, value) => {
    const updatedItems = hardwareItems.map(item =>
      item.id === id
        ? { ...item, [field]: field === 'quantity' ? parseInt(value) || 0 : value }
        : item
    );

    const ipDectHandset = updatedItems.find(item => item.name === 'Yealink W73H DECT');
    const ipDectHandsetQty = ipDectHandset?.quantity || 0;

    const adjustedItems = updatedItems.map(item => {
      if (item.name === 'IP DECT Base') {
        return { ...item, quantity: ipDectHandsetQty > 0 ? 1 : 0 };
      }
      return item;
    });

    let mobileAppQty = adjustedItems.find(item => item.name === 'Mobile App')?.quantity || 0;

    if (autoCalculateMobileApp) {
      mobileAppQty = adjustedItems.reduce((sum, item) => {
        if (['T54W', 'T57W', 'T58W','YEALINK T88', 'Yealink W73H DECT', 'Mobile App Addon'].includes(item.name)) {
          return sum + item.quantity;
        }
        return sum;
      }, 0);

      adjustedItems.forEach(item => {
        if (item.name === 'Mobile App') {
          item.quantity = mobileAppQty;
        }
      });
    }

    const finalItems = adjustedItems;

    const voiceMail = finalItems.reduce((sum, item) => {
      if (['T54W', 'T57W', 'T58W','YEALINK T88'].includes(item.name)) {
        return sum + item.quantity;
      }
      return sum;
    }, 0);

    const updatedAdditionalHardware = additionalHardware.map(item => {
      if (item.id === id) {
        return { ...item, [field]: field === 'quantity' ? parseInt(value) || 0 : value };
      }
      if (item.name === 'Voicemail ports') {
        return { ...item, quantity: voiceMail };
      }
      if (item.name === 'Cat 5E Cable (5m)') {
        const handsetSum = finalItems.reduce((sum, handsetItem) => {
          if (['T54W', 'T57W', 'T58W','YEALINK T88', 'Yealink W73H DECT'].includes(handsetItem.name)) {
            return sum + (handsetItem.quantity || 0);
          }
          return sum;
        }, 0);
        return { ...item, quantity: handsetSum };
      }
      return item;
    });

    setHardwareItems(finalItems);
    setAdditionalHardware(updatedAdditionalHardware);
    setCurrentLines(prev => ({
      ...prev,
      hostedLifetimeLicenses: mobileAppQty
    }));
    setHasUnsavedChanges(true);
  };

  const handleHardwareFocus = (id, field) => (e) => {
    const updatedItems = hardwareItems.map(item =>
      item.id === id ? { ...item, [field]: '' } : item
    );
    setHardwareItems(updatedItems);
  };

  const handleHardwareBlur = (id, field) => (e) => {
    const value = e.target.value === '' || e.target.value === null ? 0 : parseInt(e.target.value) || 0;
    // Force update state directly so empty strings never persist
    setHardwareItems(prev =>
      prev.map(item => item.id === id ? { ...item, [field]: value } : item)
    );
    handleEditItem(id, field, value);
  };

  const handleAdditionalHardwareFocus = (id, field) => (e) => {
    const updatedItems = additionalHardware.map(item =>
      item.id === id ? { ...item, [field]: '' } : item
    );
    setAdditionalHardware(updatedItems);
  };

  const handleAdditionalHardwareBlur = (id, field) => (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
    const updatedItems = additionalHardware.map(item =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setAdditionalHardware(updatedItems);
    handleEditItem(id, field, value);
  };

  const handleDeleteItem = (id) => {
    setHardwareItems(hardwareItems.filter(item => item.id !== id));
    setHasUnsavedChanges(true);
  };

  const groupedItems = hardwareItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  useEffect(() => {
    setFormData(prev => ({ ...prev, connection_id: selectedConnectionId }));
  }, [selectedConnectionId]);

  const calculateAllCosts = useMemo(() => {
    if (!services || !currentLines || !dataBroadband || !lineRequirements || !hardwareItems) {
      return { totalMonthly: 0 };
    }

    const getPrice = (serviceName) => {
      const service = services.find(s => s.name === serviceName);
      const price = service ? parseFloat(service.price) : 0;
      return parseFloat(price.toFixed(2));
    };

    const roundToTwo = (num) => {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2));
    };

    const fibre_fail_safe_sum = currentLines.adslFttcBroadband + currentLines.new4g5gBroadband + currentLines.fttpSogeaBroadband;

    const costs = {
      sogea: roundToTwo(currentLines.fttpSogeaBroadband * getPrice('SOGEA')),
      adsl: roundToTwo(currentLines.adslFttcBroadband * getPrice('FTTC BB')),
      fourG5g: roundToTwo(currentLines.new4g5gBroadband * getPrice('4G BB')),
      starlink: roundToTwo(dataBroadband.starlinkBroadband * getPrice('STARLINK')),
      analogue: roundToTwo(currentLines.analoguePstnLines * getPrice('ANALOGUE LINE')),
      isdn2: roundToTwo(lineRequirements.existingIsdn2Channels * getPrice('ISDN 2 CH')),
      t58w: roundToTwo((hardwareItems.find(i => i.name === 'T58W')?.quantity || 0) * getPrice('T58W')),
      yealink: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T88')?.quantity || 0) * getPrice('YEALINK T88')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getPrice('T57W')),
      t54w: roundToTwo((hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) * getPrice('T54W')),
      dect: roundToTwo((hardwareItems.find(i => i.name === 'Yealink W73H DECT')?.quantity || 0) * getPrice('DECT')),
      mobileApp: roundToTwo((hardwareItems.find(i => i.name === 'Mobile App')?.quantity || 0) * getPrice('LICENSE MAINT')),
      fibre_safe: getPrice('FIBRE SAFE'),
      isdn_2_ch: getPrice('ISDN 2 CH'),
      fibre_web_listing: getPrice('FIBRE AI'),
      fibre_audio: (hardwareItems.find(i => i.name === 'Fibre Audio')?.quantity || 0) + getPrice('FIBRE AUDIO'),
      sip_trunck: roundToTwo((hardwareItems.find(i => i.name === 'Mobile App')?.quantity || 0) * getPrice('SIP TRUNK BUNDLE')),
      fibre_fail_safe: roundToTwo(fibre_fail_safe_sum * getPrice('FIBRE FAILSAFE')),
     // leased_line: roundToTwo(dataBroadband.leasedLines * getPrice('LEASED LINE')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getPrice('T57W')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getPrice('T57W')),
      grandstream3470: roundToTwo((hardwareItems.find(i => i.name === 'GRANDSTREAM 3470')?.quantity || 0) * getPrice('GRANDSTREAM 3470')),
      grandstream3480: roundToTwo((hardwareItems.find(i => i.name === 'GRANDSTREAM 3480')?.quantity || 0) * getPrice('GRANDSTREAM 3480')),
      cisco9871: roundToTwo((hardwareItems.find(i => i.name === 'CISCO 9871')?.quantity || 0) * getPrice('CISCO 9871')),


    };

    costs.totalMonthly = roundToTwo(
      Object.values(costs).reduce((sum, value) => sum + parseFloat(value || 0), 0)
    );
   

    return costs;
  }, [services, currentLines, dataBroadband, lineRequirements, hardwareItems]);
  

  const calculateTotalHardwareCosts = useMemo(() => {
    if (!equipments || !currentLines || !dataBroadband || !lineRequirements || !hardwareItems) {
      return { totalMonthly: 0 };
    }

    const getEquipmentPrice = (equipmentName) => {
      const equipment = equipments.find(s => s.name === equipmentName);
      const price = equipment ? parseFloat(equipment.price) : 0;
      return parseFloat(price.toFixed(2));
    };

    const roundToTwo = (num) => {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2));
    };

    const doorEntryQuantity =
      (additionalHardware.find(i => i.name === 'Pancode')?.quantity || 0) +
      (additionalHardware.find(i => i.name === '1 Button Entry')?.quantity || 0);

    const cable5e =
      (hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'T58W')?.quantity || 0);

    const lg_tv =
      (hardwareItems.find(i => i.name === 'Fibre TV/Wallboard')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'Add On')?.quantity || 0);

    const equiment_costs = {
      hostedLifetimeLicenses: roundToTwo(currentLines.hostedLifetimeLicenses * getEquipmentPrice('SINGLE LIFETIME HOSTED LICENSE')),
      t54w: roundToTwo((hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) * getEquipmentPrice('T54W')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getEquipmentPrice('T57W')),
      t58w: roundToTwo((hardwareItems.find(i => i.name === 'T58W')?.quantity || 0) * getEquipmentPrice('T58W PRO')),
      yealink: roundToTwo((hardwareItems.find(i => i.name === 'YEALINK T88')?.quantity || 0) * getEquipmentPrice('YEALINK T88')),
      number_port: getEquipmentPrice('NUMBER PORT'),
      new_number: getEquipmentPrice('NEW NUMBER PROVISION 2-9'),
      dect: roundToTwo((hardwareItems.find(i => i.name === 'Yealink W73H DECT')?.quantity || 0) * getEquipmentPrice('IP DECT')),
      bell: roundToTwo((hardwareItems.find(i => i.name === 'Bell / Tannoy')?.quantity || 0) * getEquipmentPrice('SIPP BELL')),
      headset: roundToTwo((hardwareItems.find(i => i.name === 'Headsets')?.quantity || 0) * getEquipmentPrice('WIRELESS HEADSET')),
      doorentry: roundToTwo(doorEntryQuantity * getEquipmentPrice('DOOR ENTRY SYSTEM (AVERAGE ONE)')),
      ipad: roundToTwo((hardwareItems.find(i => i.name === 'iPad')?.quantity || 0) * getEquipmentPrice('IPAD')),
      cat5e: roundToTwo((additionalHardware.find(i => i.name === 'Cat 5')?.quantity || 0) * getEquipmentPrice('CAT 5E CABLING')),
      sitemove: roundToTwo((additionalHardware.find(i => i.name === 'System Moves')?.quantity || 0) * getEquipmentPrice('SITE MOVE')),
      poe_switch: getEquipmentPrice('Netgear GS108LP SWITCH'),
      draytek_wifi: getEquipmentPrice('DRAYTEK WI-FI ROUTER'),
      robustel_4g_router: roundToTwo(currentLines.new4g5gBroadband * getEquipmentPrice('ROBUSTEL 4G ROUTER')),
      new_base_line: roundToTwo(currentLines.analoguePstnLines * getEquipmentPrice('NEW BASIC LINE')),
      override_comms: getEquipmentPrice('OVERRIDE COMMS'),
      tital_cat5cable: (cable5e * getEquipmentPrice('TITAL CAT 5 CABLE (2M)')),
      installation_charge: getEquipmentPrice('INSTALLATION CHARGE'),
      wifi: roundToTwo((hardwareItems.find(i => i.name === 'Wi-Fi Booster')?.quantity || 0) * getEquipmentPrice('WIFI BOOSTER')),
      lg_tv: roundToTwo(lg_tv * getEquipmentPrice('LG TV')),
      star_link: roundToTwo(dataBroadband.starlinkBroadband * getEquipmentPrice('STARLINK')),
      admin_fee: getEquipmentPrice('ADMIN FEE'),
      grandstream3470: roundToTwo((hardwareItems.find(i => i.name === 'GRANDSTREAM 3470')?.quantity || 0) * getEquipmentPrice('GRANDSTREAM 3470')),
      grandstream3480: roundToTwo((hardwareItems.find(i => i.name === 'GRANDSTREAM 3480')?.quantity || 0) * getEquipmentPrice('GRANDSTREAM 3480')),
      cisco9871: roundToTwo((hardwareItems.find(i => i.name === 'CISCO 9871')?.quantity || 0) * getEquipmentPrice('CISCO 9871')),

    };
    console.log("equiment_costs",equiment_costs);

    equiment_costs.totalCost = roundToTwo(
      Object.values(equiment_costs).reduce((sum, value) => sum + parseFloat(value || 0), 0)
    );

    return equiment_costs;
  }, [services, equipments, currentLines, dataBroadband, lineRequirements, hardwareItems]);

  const calculateItServicesCost = useMemo(() => {
    const stations = parseInt(itServicesData.numberOfStations) || 0;

    const getItSupportPrice = (name) => {
      const item = itSupportPricing.find(i => i.name === name);
      return item ? parseFloat(item.price) || 0 : 0;
    };
    const getLicencePrice = (name) => {
      const item = licenses.find(l => l.name === name);
      return item ? parseFloat(item.price) || 0 : 0;
    };
    const roundToTwo = (num) => parseFloat((Math.round(num * 100) / 100).toFixed(2));

    const licenceBreakdown = licenses.map(license => {
      const qty = parseInt(itServicesData.licenceQuantities[license.id]) || 0;
      const price = parseFloat(license.price) || 0;
      return {
        id: license.id,
        name: license.name,
        price,
        quantity: qty,
        lineTotal: roundToTwo(qty * price)
      };
    });

    const licenceCost = roundToTwo(licenceBreakdown.reduce((sum, l) => sum + l.lineTotal, 0));
    const totalLicenceQuantity = licenceBreakdown.reduce((sum, l) => sum + l.quantity, 0);

    const itSupportPrice = getItSupportPrice('IT SUPPORT (PER STATION)');
    const basePerStationPrice = getItSupportPrice('PER STATION + MICROSOFT LICENCE BASIC');
    const standardLicencePrice = getLicencePrice('MICROSOFT BUSINESS STANDARD');
    const premiumLicencePrice = getLicencePrice('MICROSOFT BUSINESS PREMIUM');
    const itServicePrice = getItSupportPrice('IT SERVICE');

    const stationPackages = {
      it_support: { label: 'IT Support only', price: itSupportPrice },
      basic: { label: '+ Microsoft Business Basic', price: basePerStationPrice },
      standard: { label: '+ Microsoft Business Standard', price: roundToTwo(basePerStationPrice + standardLicencePrice) },
      premium: { label: '+ Microsoft Business Premium', price: roundToTwo(basePerStationPrice + premiumLicencePrice) },
    };

    const selectedKeys = itServicesData.selectedPackages || [];
    const perStationPrice = roundToTwo(
      selectedKeys.reduce((sum, key) => sum + (stationPackages[key]?.price || 0), 0)
    );
    const stationCost = roundToTwo(stations * perStationPrice);
    const itServiceCost = roundToTwo(itServicePrice);
    const total = roundToTwo(licenceCost + stationCost + itServiceCost);

    return {
      licenceBreakdown,
      licenceCost,
      totalLicenceQuantity,
      stationPackages,
      perStationPrice,
      stationCost,
      itServicePrice,
      itServiceCost,
      total,
    };
  }, [itServicesData, licenses, itSupportPricing]);

  const [formData, setFormData] = useState({
    mainContact: '',
    mainSellingPoint: '',
    sellingPointNotes: '',
    confirmedNumbers: 'Yes',
    billedByVirgin: 'No',
    hasBTFeatureLine: 'No',
    line1: '', line7: '',
    line2: '', line8: '',
    line3: '', line9: '',
    line4: '', line10: '',
    line5: '', line11: '',
    line6: '', line12: '',
    estimatedCallSpend: '0',
    hasSIPVoIP: 'No',
    ctiExpectations: 'Both',
    hasITRep: 'No',
    itContactDetails: '',
    stopStartRecording: 'Yes',
    multipleSites: 'No',
    siteAddresses: '',
    installAtCurrentPremises: 'Yes',
    newPremisesAddress: '',
    newPremisesDate: '',
    hasAddOns: 'No',
    addOnDetails: '',
    siteNotes: '',
    installNotes: '',
    lpdNetworkNotes: '',
    otherNotes: '',
    companyName: '0',
    orderDate: '09/01/2025',
    soldTariff: 'FIBRE SIP BUNDLE',
    reductionPerson: '',
    reductionReason: '',
    servicesAffected: '',
    newRates: '',
    termLength: '',
    totalCredit: '',
    costToFibre: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleFocus = (key, valueSetter) => (e) => {
    if (e.target.value === '0') {
      valueSetter(key, '');
    }
  };

  const handleBlur = (key, valueSetter) => (e) => {
    if (e.target.value === '') {
      valueSetter(key, '0');
    }
  };

  const handleServiceChargesData = (updatedCharges) => {
    setServiceChargesData(updatedCharges);
    setHasUnsavedChanges(true);
  };

  const handleLeaseDataUpdate = (updatedLease) => {
    setLeaseCalculatorData(updatedLease);
    setHasUnsavedChanges(true);
  };

  useEffect(() => {
    if (savedDigitalServices && Object.keys(savedDigitalServices).length > 0) {
      setDigitalServicesData(savedDigitalServices);
    }
  }, [savedDigitalServices, selectedConnectionId]);

  const handleDigitalServicesUpdate = (data) => {
    setDigitalServicesData(data);
    setSavedDigitalServices(data);
    setHasUnsavedChanges(true);
  };

  const handleSaveSystemConfig = async (action = "continue") => {
    setIsSaving(true);
    try {
      const systemConfigData = {
        connectionId: selectedConnectionId,
        lineRequirements,
        currentLines,
        dataBroadband,
        notes,
        hardwareItems: hardwareItems.map(item => ({
          ...item,
          type: "standard",
          quantity: parseInt(item.quantity) || 0,
        })),
        additionalHardware: additionalHardware.map(item => ({
          ...item,
          type: "additional",
        })),
        telecom_services: telecomServices.map(service => ({
          description: service.description || '',
          existing_tel_no: service.existing_tel_no || '',
          postcode: service.postcode || '',
          quantity: service.quantity || 0,
          service_type: service.service_type || '',
        })),
        serviceCharges: serviceChargesData,
        itServices: itServicesData,
        itServicesTotal: calculateItServicesCost.total,
        totalMonthlyCost: calculateAllCosts.totalMonthly,
        leasedLines: dataBroadband.leasedLines,
        totalEquipmentCost: calculateTotalHardwareCosts.totalCost,
        leaseCalculatorData: {
          ...leaseCalculatorData,
          paymentProfile: leaseCalculatorData.paymentProfile.toString(),
          networkPayment: leaseCalculatorData.networkPayment.toString(),
          networkSettlementContribution: Number(leaseCalculatorData.networkSettlementContribution),
          digital_services: savedDigitalServices || digitalServicesData,
        },
      };
      console.log("systemConfigData",systemConfigData);
      const result = await saveSystemConfig(systemConfigData);
    
      await QuoteProgressService.saveStep({
        quoteId: selectedConnectionId,
        stepName: "system_config",
        completed: true,
        actions: { action },
      });

      // Mark as saved
      setHasUnsavedChanges(false);
      setSavedOnce(true);

      if (action === "exit") {
        window.location.reload();
      } else if (action === "continue") {
        onSaveSuccess(true);
      }

      return result;
    } catch (error) {
      console.error("Operation failed:", error);
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  // ── Shared button with pulsing dot ──
  const SaveButton = ({ action, label, colorClass, disabled: extraDisabled = false }) => (
    <button
      type="button"
      onClick={() => handleSaveSystemConfig(action)}
      disabled={isSaving || extraDisabled}
      className={`relative ${colorClass} text-white px-6 py-3 rounded-lg font-semibold flex items-center space-x-2 disabled:opacity-50 transition-all duration-200
        ${hasUnsavedChanges ? 'shadow-lg shadow-orange-300/50 ring-2 ring-orange-400 ring-offset-1' : ''}
      `}
    >
      {hasUnsavedChanges && !isSaving && (
        <span className="absolute -top-1.5 -right-1.5 flex h-3.5 w-3.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3.5 w-3.5 bg-orange-500"></span>
        </span>
      )}
      {isSaving ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          <span>Saving...</span>
        </>
      ) : (
        <>
          <CheckCircle className="w-5 h-5" />
          <span>{label}</span>
        </>
      )}
    </button>
  );

  return (
    <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-blue-100">

      {/* ── TOP ACTION BAR ── */}
      <div className={`px-6 py-4 flex items-center justify-between border-b transition-colors duration-300
        ${hasUnsavedChanges
          ? 'bg-gradient-to-r from-orange-50 to-amber-50 border-orange-200'
          : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-100'
        }`}
      >
        <div className="flex items-center space-x-3">
          <Settings className="w-5 h-5 text-blue-700" />
          <div>
            <p className="text-sm font-semibold text-gray-800">System Configuration</p>
            {hasUnsavedChanges ? (
              <p className="text-xs text-orange-600 font-medium flex items-center space-x-1">
                <span className="inline-block w-1.5 h-1.5 bg-orange-500 rounded-full"></span>
                <span>Please save before continuing  or you'll lose your work</span>
              </p>
            ) : savedOnce ? (
              <p className="text-xs text-green-600 font-medium flex items-center space-x-1">
                <CheckCircle className="w-3 h-3" />
                <span>All changes saved</span>
              </p>
            ) : (
              <p className="text-xs text-gray-500">Fill in the details below, then Save & Continue</p>
            )}
          </div>
        </div>

        {/* Quick save buttons in top bar */}
        <div className="flex items-center space-x-2">
          <SaveButton
            action="exit"
            label="Save & Exit"
            colorClass="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
          />
          <SaveButton
            action="continue"
            label="Save & Continue"
            colorClass="bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700"
            disabled={(leaseCalculatorData?.salesRepCommission ?? 0) < 0}
          />
        </div>
      </div>

      

      {/* LINE SERVICES Accordion */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsLineServicesOpen(!isLineServicesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Settings className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">LINE SERVICES</h2>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isLineServicesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isLineServicesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isLineServicesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
          <TelecomServicesSection
            services={telecomServices}
            onServiceChange={handleServiceChange}
            onAddService={handleAddService}
            onRemoveService={handleRemoveService}
          />

          <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 shadow-md">
            <div className="flex items-center justify-center space-x-2">
              <Wifi className="w-5 h-5" />
              <h3 className="font-bold text-lg">LINE REQUIREMENTS</h3>
            </div>
          </div>

          <div className="p-6">
            <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
              <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                <h4 className="font-semibold text-blue-800 text-center">New Lines & Internet</h4>
              </div>

              <div className="space-y-1">
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Hosted Lifetime Licenses with SIP Trunk</span>
                  <input
                    type="number"
                    value={currentLines.hostedLifetimeLicenses}
                    onChange={(e) => handleCurrentLinesChange('hostedLifetimeLicenses', e.target.value)}
                    onFocus={handleFocus('hostedLifetimeLicenses', handleCurrentLinesChange)}
                    onBlur={handleBlur('hostedLifetimeLicenses', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>

                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">New 4G / 5G Broadband</span>
                  <input
                    type="number"
                    value={currentLines.new4g5gBroadband}
                    onChange={(e) => handleCurrentLinesChange('new4g5gBroadband', e.target.value)}
                    onFocus={handleFocus('new4g5gBroadband', handleCurrentLinesChange)}
                    onBlur={handleBlur('new4g5gBroadband', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>

                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center">
                  <span className="text-gray-700 font-medium">FTTP / SoGEA Broadband</span>
                  <input
                    type="number"
                    value={currentLines.fttpSogeaBroadband}
                    onChange={(e) => handleCurrentLinesChange('fttpSogeaBroadband', e.target.value)}
                    onFocus={handleFocus('fttpSogeaBroadband', handleCurrentLinesChange)}
                    onBlur={handleBlur('fttpSogeaBroadband', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>

                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Starlink Broadband</span>
                  <input
                    type="number"
                    value={dataBroadband.starlinkBroadband}
                    onChange={(e) => handleDataBroadbandChange('starlinkBroadband', e.target.value)}
                    onFocus={handleFocus('starlinkBroadband', handleDataBroadbandChange)}
                    onBlur={handleBlur('starlinkBroadband', handleDataBroadbandChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>

                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Leased Lines</span>
                  <input
                    type="number"
                    value={dataBroadband.leasedLines}
                    onChange={(e) => handleDataBroadbandChange('leasedLines', e.target.value)}
                    onFocus={handleFocus('leasedLines', handleDataBroadbandChange)}
                    onBlur={handleBlur('leasedLines', handleDataBroadbandChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* HARDWARE Accordion */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsHardwareOpen(!isHardwareOpen)}
      >
        <div className="flex items-center space-x-3">
          <Monitor className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">HARDWARE</h2>
          <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
            {hardwareItems.length} items
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isHardwareOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isHardwareOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isHardwareOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
          <div className="p-6 space-y-6">
           {Object.entries(groupedItems).map(([category, items]) => (
  <div key={category} className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
    <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {getIconComponent(category)}
          <h4 className="font-bold text-blue-800">{category}</h4>
          <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium">
            {items.length}
          </span>
        </div>
      </div>
    </div>

    {/* Dropdown selector — Phone category only */}
    {category === 'Phone' && (
      <div className="px-4 py-3 border-b border-blue-100 bg-blue-50 flex items-center space-x-3">
        <label className="text-xs font-semibold text-blue-700 whitespace-nowrap">
          Select additional handset model:
        </label>
        <select
            value={selectedPhoneModel}
            onChange={(e) => {
              const newModel = e.target.value;
              const dropdownModels = ['GRANDSTREAM 3470', 'GRANDSTREAM 3480', 'CISCO 9871'];

              // Reset ALL dropdown models to 0, then the selected one will show with 0 ready to edit
              setHardwareItems(prev =>
                prev.map(item =>
                  dropdownModels.includes(item.name)
                    ? { ...item, quantity: 0 }
                    : item
                )
              );

              setSelectedPhoneModel(newModel);
              setHasUnsavedChanges(true);
            }}
            className="px-2 py-1 border-2 border-blue-300 rounded-lg text-xs text-gray-700 bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
          >
          <option value="">— None —</option>
          <option value="GRANDSTREAM 3470">GRANDSTREAM 3470</option>
          <option value="GRANDSTREAM 3480">GRANDSTREAM 3480</option>
          <option value="CISCO 9871">CISCO 9871</option>
        </select>
      </div>
    )}

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
      {items
       .filter(item => {
          const dropdownModels = ['GRANDSTREAM 3470', 'GRANDSTREAM 3480', 'CISCO 9871'];
          if (dropdownModels.includes(item.name)) {
            return item.name === selectedPhoneModel || (item.quantity ?? 0) > 0;
          }
          return true;
        })
        .map(item => (
          <div key={item.id} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200 hover:shadow-md transition-all duration-200">
            <div className="flex justify-between items-start mb-3">
              <div className="flex items-center space-x-3">
                {item.icon.startsWith('/images') ? (
                  <img
                    src={item.icon}
                    alt={item.name}
                    className="w-13 h-12 object-contain rounded-md"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/images/placeholder.jpg';
                      e.target.className = 'w-12 h-12 object-contain rounded-md bg-gray-100';
                    }}
                  />
                ) : (
                  <span className="text-2xl">{item.icon}</span>
                )}
                <div>
                  {editingId === item.id ? (
                    <input
                      type="text"
                      value={item.name}
                      onChange={(e) => handleEditItem(item.id, 'name', e.target.value)}
                      className="font-semibold text-gray-800 bg-white border border-blue-300 rounded px-2 py-1 text-sm"
                      onBlur={() => setEditingId(null)}
                      onKeyPress={(e) => e.key === 'Enter' && setEditingId(null)}
                      autoFocus
                    />
                  ) : (
                    <h5 className="font-semibold text-gray-800 cursor-pointer hover:text-blue-600">
                      {item.name}
                    </h5>
                  )}
                  <p className="text-xs text-gray-600">{item.category}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-600">Quantity:</span>
                <input
                  type="number"
                  value={item.quantity}
                  onChange={(e) => handleEditItem(item.id, 'quantity', e.target.value)}
                  onFocus={handleHardwareFocus(item.id, 'quantity')}
                  onBlur={handleHardwareBlur(item.id, 'quantity')}
                  className="w-20 px-2 py-1 border-2 rounded-lg text-center font-semibold bg-white text-blue-700 border-blue-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
                  min="0"
                />
              </div>
            </div>
          </div>
        ))}
    </div>
  </div>
))}
          </div>

          <div className="p-6 space-y-6">
            {Object.entries(
              additionalHardware.reduce((acc, item) => {
                acc[item.category] = acc[item.category] || [];
                acc[item.category].push(item);
                return acc;
              }, {})
            ).map(([category, items]) => (
              <div key={category} className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                  <div className="flex items-center space-x-2">
                    {getIconComponent(category)}
                    <h4 className="font-bold text-blue-800">{category}</h4>
                    <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                      {items.length}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                  {items.map((item) => {
                    const isEmail = item.category === 'E-mail';
                    const otherTotal = 90;
                    const computedQuantity = isEmail
                      ? (parseInt(emailExtraInput) || 0) + otherTotal
                      : item.quantity;

                    return (
                      <div
                        key={item.id || item.name}
                        className="bg-white border border-blue-200 rounded-xl p-4 shadow-sm transition hover:shadow-md space-y-4"
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            {item.icon.startsWith('/images') ? (
                              <img
                                src={item.icon}
                                alt={item.name}
                                className="w-13 h-12 object-contain rounded-md"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = '/images/placeholder.jpg';
                                  e.target.className = 'w-12 h-12 object-contain rounded-md bg-gray-100';
                                }}
                              />
                            ) : (
                              <span className="text-2xl">{item.icon}</span>
                            )}
                            <h5 className="font-semibold text-blue-800">{item.name}</h5>
                            <p className="text-xs text-gray-500">{item.category}</p>
                          </div>
                        </div>

                        <div className="flex justify-between items-center">
                          <label className="text-sm text-gray-700 font-medium">Quantity</label>
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => handleEditItem(item.id, 'quantity', parseInt(e.target.value))}
                            onFocus={handleAdditionalHardwareFocus(item.id, 'quantity')}
                            onBlur={handleAdditionalHardwareBlur(item.id, 'quantity')}
                            className="w-20 px-2 py-1 border border-blue-300 rounded-lg text-right font-semibold text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
                            min="0"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
       {/* ── IT SERVICES / MICROSOFT LICENCE RESALE ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsItServicesOpen(!isItServicesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Globe className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">IT SERVICES & MICROSOFT LICENCES</h2>
          {calculateItServicesCost.total > 0 && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              £{calculateItServicesCost.total.toFixed(2)}/mo
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isItServicesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isItServicesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isItServicesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 space-y-6">

          {/* Microsoft licences */}
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Microsoft 365 Licences</h4>
            </div>
            {licenses.length === 0 ? (
              <div className="p-4 text-sm text-gray-500 text-center">
                No licence pricing found — add licences in the Mechanics Calculator first.
              </div>
            ) : (
              <div className="divide-y divide-blue-100">
                {licenses.map(license => {
                  const qty = itServicesData.licenceQuantities[license.id] ?? 0;
                  const lineTotal = calculateItServicesCost.licenceBreakdown.find(l => l.id === license.id)?.lineTotal || 0;
                  return (
                    <div key={license.id} className="p-4 hover:bg-blue-50 transition-colors duration-200">
                      <div className="flex justify-between items-center">
                        <div>
                          <span className="text-gray-700 font-medium">{license.name}</span>
                          <span className="ml-2 text-xs text-gray-500">
                            £{parseFloat(license.price).toFixed(2)} / licence / month
                          </span>
                        </div>
                        <div className="flex items-center space-x-3">
                          <input
                            type="number"
                            value={qty}
                            onChange={(e) => handleLicenceQuantityChange(license.id, e.target.value)}
                            onFocus={handleFocus(license.id, () => {})}
                            className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                            min="0"
                            placeholder="0"
                          />
                          <span className="w-20 text-right text-sm font-semibold text-gray-700">
                            £{lineTotal.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Stations & Package */}
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Stations & IT Service</h4>
            </div>
            <div className="p-4 space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-700 font-medium">Number of Stations</span>
                <input
                  type="number"
                  value={itServicesData.numberOfStations}
                  onChange={(e) => handleStationsChange(e.target.value)}
                  onFocus={handleFocus('numberOfStations', (field, val) => handleStationsChange(val))}
                  onBlur={handleBlur('numberOfStations', (field, val) => handleStationsChange(val))}
                  className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                  min="0"
                />
              </div>

              <div className="pt-3 border-t border-blue-100">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Station Package (per station — select any combination)
                </label>
                <div className="space-y-2">
                  {Object.entries(calculateItServicesCost.stationPackages).map(([key, pkg]) => (
                    <label
                      key={key}
                      className="flex items-center justify-between p-2 rounded-lg border border-blue-100 hover:bg-blue-50 cursor-pointer"
                    >
                      <span className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={(itServicesData.selectedPackages || []).includes(key)}
                          onChange={(e) => handleTogglePackage(key, e.target.checked)}
                          className="w-4 h-4 rounded accent-blue-500 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">{pkg.label}</span>
                      </span>
                      <span className="text-sm font-semibold text-blue-700">
                        £{pkg.price.toFixed(2)} / station
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="flex justify-between items-center pt-3 border-t border-blue-100">
                <span className="text-sm font-medium text-gray-700">
                  Total ({parseInt(itServicesData.numberOfStations) || 0} stations × £{calculateItServicesCost.perStationPrice.toFixed(2)})
                </span>
                <span className="text-sm font-bold text-blue-700">
                  £{calculateItServicesCost.stationCost.toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="max-w-3xl mx-auto bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-200 p-4 space-y-2">
            <div className="flex justify-between text-sm text-gray-600">
              <span>Microsoft licences ({calculateItServicesCost.totalLicenceQuantity} total)</span>
              <span>£{calculateItServicesCost.licenceCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>Station packages ({parseInt(itServicesData.numberOfStations) || 0} stations × £{calculateItServicesCost.perStationPrice.toFixed(2)})</span>
              <span>£{calculateItServicesCost.stationCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>IT service charge</span>
              <span>£{calculateItServicesCost.itServiceCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-blue-200">
              <span className="text-sm font-semibold text-gray-800">Total</span>
              <span className="text-lg font-bold text-green-600">
                £{calculateItServicesCost.total.toFixed(2)} / month
              </span>
            </div>
          </div>
        </div>
      )}


      <CallCostsComponent
        isHostedLifetimeLicenses={currentLines.hostedLifetimeLicenses}
        selectedConnectionId={selectedConnectionId}
        totalMonthlyCost={calculateAllCosts.totalMonthly}
        leasedLines={dataBroadband.leasedLines}
        totalEquipmentCost={calculateTotalHardwareCosts.totalCost}
        onServiceChargesUpdate={handleServiceChargesData}
        onLeaseDataUpdate={handleLeaseDataUpdate}
        serviceChargesData={serviceChargesData}
        leaseCalculatorData={leaseCalculatorData}
        hardwareItems={hardwareItems}
        additionalHardware={additionalHardware}
        currentLines={currentLines}
        dataBroadband={dataBroadband}
        lineRequirements={lineRequirements}
        telecomServices={telecomServices}
        adminUpdate={adminUpdate}
        onDigitalServicesUpdate={handleDigitalServicesUpdate}
        savedDigitalServices={savedDigitalServices || digitalServicesData}
      />
      {/* ── NOTES SECTION ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsNotesOpen(!isNotesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Edit2 className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">NOTES</h2>
         
          {(notes ?? '').trim() && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              {(notes ?? '').trim().split(/\s+/).length} words
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isNotesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isNotesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isNotesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6">
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Internal Notes</h4>
            </div>
            <div className="p-4">
            
              <textarea
                value={notes ?? ''}
                onChange={(e) => {
                  setNotes(e.target.value);
                  setHasUnsavedChanges(true);
                }}
                placeholder="Add any internal notes about this customer or configuration here..."
                rows={8}
                className="w-full px-4 py-3 border-2 border-blue-200 rounded-lg text-gray-700 text-sm leading-relaxed resize-y focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 placeholder-gray-400"
              />
              <p className="text-xs text-gray-400 mt-2 text-right">
                {notes?.length} characters
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ── BOTTOM SAVE BUTTONS ── */}
      <div className="flex justify-end mt-6 space-x-4">
        <SaveButton
          action="exit"
          label="Save & Exit"
          colorClass="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
        />
        <SaveButton
          action="continue"
          label="Save & Continue"
          colorClass="bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700"
          disabled={(leaseCalculatorData?.salesRepCommission ?? 0) < 0}
        />
      </div>
    </div>
  );
};

export default SystemConfig;